module.exports = require('./helpers/bundle-url').getBundleURL('hmjwG') + "aws-logo.9b34d3da.png";